<div
  class="modal add-market-standard-modal-backdrop"
  style="display: block !important; background: #0000007a"
  id="content"
>
  <div class="modal-dialog add-market-standard-dialog">
    <div class="modal-content add-market-standard-dialog-content">
      <div class="add-market-standard-dialog-body">
        <h4 class="add-market-standard-dialog-title">
          Add "{{ standardTitle }}" to Market Standard ?
        </h4>

        <p class="add-market-standard-dialog-question">
          Are you sure you want to Add this Global Approved Solution?
        </p>
        <p class="add-market-standard-dialog-message">
          Once Added, it will become a mandatory Market Standard for your market
          and will be available to Basic Users under Operational Standards.
        </p>
      </div>

      <div class="add-market-standard-dialog-footer">
        <button
          type="button"
          class="add-market-standard-btn add-market-standard-btn-cancel"
          (click)="cancel()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="add-market-standard-btn add-market-standard-btn-confirm"
          (click)="confirm()"
        >
          Yes, Add
        </button>
      </div>
    </div>
  </div>
</div>
